import React, { useEffect, useState } from "react";
import "../styles/knowledgeBase.scss";
import Dropdown from "react-bootstrap/Dropdown";
import CommonInput from "../Components/CommonInput";
import { category_finding, findings_solution_details } from "../services";
import ScreenLoader from "../Components/ScreenLoader";
import SceenLoader from "../Components/ScreenLoader";


const KnowledgeBase = () => {

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [findings, setFindings] = useState([]);
    const [selectedFinding, setSelectedFinding] = useState('');
    const [solution, setSolution] = useState("");
    const [loadingFindings, setLoadingFindings] = useState(false);
    const [loadingSolution, setLoadingSolution] = useState(false);
    const [allFindings, setAllFindings] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    // Fetch categories on mount


    const fetchCategories = async () => {
        try {
            const resp = await category_finding();
            const categoryData = resp?.statusCode?.response_data?.data?.categories || [];

            // Get saved selections from localStorage
            const savedCategory = localStorage.getItem("selectedCategory");
            const savedFinding = localStorage.getItem("selectedDescription");

            // Prepare category names
            const categoryNames = categoryData.map((c) => c.category);
            setCategories(categoryNames);

            if (savedCategory && categoryNames.includes(savedCategory)) {
                setSelectedCategory(savedCategory);

                const matchedCategory = categoryData.find(c => c.category === savedCategory);
                const findingsForCategory = matchedCategory?.findings || [];

                setFindings(findingsForCategory);
                setAllFindings(findingsForCategory); // Save master list for search

                if (savedFinding && findingsForCategory.includes(savedFinding)) {
                    setSelectedFinding(savedFinding);
                } else {
                    setSelectedFinding(findingsForCategory[0] || '');
                }
            } else {
                const defaultCategory = categoryNames[0] || '';
                setSelectedCategory(defaultCategory);

                const matchedCategory = categoryData.find(c => c.category === defaultCategory);
                const findingsForCategory = matchedCategory?.findings || [];

                setFindings(findingsForCategory);
                setAllFindings(findingsForCategory); // Save master list for search
                setSelectedFinding(findingsForCategory[0] || '');
            }

        } catch (err) {
            console.error("Failed to load categories", err);
        }
    };
    useEffect(() => {
        fetchCategories();
    }, []);


    // Whenever selectedCategory changes, fetch its findings
    const fetchFindings = async () => {
        setLoadingFindings(true);
        try {
            const resp = await category_finding();
            const categoryObj =
                resp?.statusCode?.response_data?.data?.categories.find(
                    (c) => c.category === selectedCategory
                );
            const f = categoryObj?.findings || [];
            setFindings(f);
            setAllFindings(f);
            if (f.length) {
                const savedFinding = localStorage.getItem("selectedDescription");
                if (savedFinding && f.includes(savedFinding)) {
                    setSelectedFinding(savedFinding);
                } else {
                    setSelectedFinding(f[0]);
                }
            } else {
                setSelectedFinding("");
                setSolution("");
            }
        } catch (err) {
            console.error("Failed to load findings", err);
        } finally {
            setLoadingFindings(false);
        }
    }

    useEffect(() => {
        if (!selectedCategory) return;
        fetchFindings();
    }, [selectedCategory,]);

    // Whenever selectedFinding changes, fetch its solution
    const fetchSolution = async () => {
        setLoadingSolution(true);
        try {
            const params = {
                category: selectedCategory,
                finding: selectedFinding,
            };
            const resp = await findings_solution_details(params);
            const sol = resp?.statusCode?.response_data?.data?.solution || "";
            setSolution(sol);
        } catch (err) {
            console.error("Failed to load solution", err);
            setSolution("");
        } finally {
            setLoadingSolution(false);
        }
    };

    useEffect(() => {
        if (!selectedFinding) return;
        fetchSolution();
    }, [selectedFinding, selectedCategory]);

    const clearSearch = () => {
        setSearchTerm('')
        setFindings(allFindings);
    };

    return (
        <div className="knowledge_base">
            <aside className="knowledge_base_sidebar">
                <div className="category mb-3">
                    <h4>Issues</h4>
                    <Dropdown className="knowledge_cstm_dropdown">
                        <Dropdown.Toggle className="font_500" id="dropdown-custom-components">
                            {selectedCategory || "Select Category"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {categories.map((cat) => (
                                <Dropdown.Item
                                    key={cat}
                                    active={cat === selectedCategory}
                                    onClick={() => setSelectedCategory(cat)}
                                >
                                    {cat}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div >

                <div className="px-3 mb-3 position-relative">
                    <CommonInput
                        placeholder="Search findings..."
                        value={searchTerm}
                        onChange={(e) => {
                            const term = e.target.value.toLowerCase();
                            setSearchTerm(term);
                            const filtered = allFindings.filter((f) =>
                                f.toLowerCase().includes(term)
                            );
                            setFindings(filtered);
                        }}
                    />
                    {searchTerm && (
                        <span
                            className="clear_icon"
                            onClick={clearSearch}
                            style={{ position: 'absolute', right: '30px', top: '40%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                        >
                            ×
                        </span>
                    )}
                </div>

                <ul className="issue_list">
                    {loadingFindings ? (
                        <SceenLoader />
                    ) : findings?.length === 0 ? (
                        <li className="no_results">No findings found</li>
                    ) : (
                        findings?.map((finding) => (
                            <li
                                key={finding}
                                className={
                                    finding === selectedFinding ? "active_finding" : " cursor_pointer"
                                }
                                onClick={() => setSelectedFinding(finding)}
                            >
                                {finding}
                            </li>
                        ))
                    )}
                </ul>

            </aside >

            <div className="solution_section">
                <div className="d-flex gap-3 mb-3 align-items-center">
                    <img
                        src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/external-attack-surface-scan.svg"
                        alt="external-attack-surface-scan"
                        height={32} width={32}
                    />
                    <h3 className="color_white mb-0 font_20 font-600">Solution</h3>
                </div>

                <div className="card">
                    {loadingSolution ? (
                        <ScreenLoader />
                    ) : solution ? (
                        <div dangerouslySetInnerHTML={{ __html: solution }} />
                    ) : (
                        <p className="color_white">
                            Select a finding to view its solution.
                        </p>
                    )}
                </div>
            </div>
        </div >
    );
};

export default KnowledgeBase;
